import { useRef, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { PrivacyPolicy, PrivacyPolicyInitAccount, TermsOfServiceGeneralInitAccount } from "./LegalNotice";
import { Spacer } from "./Utils";
import { useNavigate } from "react-router-dom";

export function TOSDialog() {
	const [open, setOpen] = useState(true);
	const navigate = useNavigate();
	const dialogContentRef = useRef(null);

	const scrollToBottom = () => {
		if (dialogContentRef.current) {
			dialogContentRef.current.scrollTo({
				top: dialogContentRef.current.scrollHeight,
				behavior: 'smooth',	// Adds the smooth scroll effect
			});
		}
	};

	return (
		<div>
		<Dialog open={open} maxWidth="md" fullWidth>
			<DialogContent ref={dialogContentRef} >
			<Button onClick={scrollToBottom}>Scroll to Bottom</Button>
			<TermsOfServiceGeneralInitAccount />
			<Spacer />
			<div className='center-flex'>
			<DialogActions>
				<Button onClick={() => navigate('/privacy-policy-dialog')}>Accept</Button>
			</DialogActions>
			</div>
			<Spacer />
			</DialogContent>
		</Dialog>
		</div>
	);
}

export function PrivacyPolicyDialog() {
	const [open, setOpen] = useState(true);
	const navigate = useNavigate();
	const dialogContentRef = useRef(null);

	const scrollToBottom = () => {
		if (dialogContentRef.current) {
			dialogContentRef.current.scrollTo({
				top: dialogContentRef.current.scrollHeight,
				behavior: 'smooth',	// Adds the smooth scroll effect
			});
		}
	};

	return (
		<div>
		<Dialog open={open} maxWidth="md" fullWidth>
			<DialogContent ref={dialogContentRef} >
			<Button onClick={scrollToBottom}>Scroll to Bottom</Button>
			<PrivacyPolicyInitAccount />
			<Spacer />
			<div className='center-flex'>
			<DialogActions>
				<Button onClick={() => navigate('/')}>Accept</Button>
			</DialogActions>
			</div>
			<Spacer />
			</DialogContent>
		</Dialog>
		</div>
	);
}

